import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { Container } from "appworks/graphics/pixi/container";
import { CenterPivot, Group, PIXIElement, ResetPivot, Ungroup } from "appworks/graphics/pixi/group";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Point } from "appworks/utils/geom/point";
import { Timer } from "appworks/utils/timer";
import * as TweenJS from "appworks/utils/tween";
import { AdjustmentFilter } from "pixi-filters";
import { BitmapText } from "../pixi/bitmap-text";
import { DualPosition } from "../pixi/dual-position";
import { Position } from "../pixi/position";
import { Sprite } from "../pixi/sprite";
import { Text } from "../pixi/text";

import TWEEN = require("appworks/utils/tween");

type Ease = (k: number) => number;
const quad = TweenJS.Easing.Quadratic;

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function ScaleInFromCentre(object: Container) {
    object.scale.set(0, 0);

    const size = new Point(object.width, object.height);
    const offset = new Point(object.x, object.y);

    new TweenJS.Tween(object.scale)
        .to({ x: 1, y: 1 }, 800)
        .onUpdate(() => {
            object.x = (size.x - object.width) * 0.5 + offset.x;
            object.y = (size.y - object.height) * 0.5 + offset.y;
        })
        .start();
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function Rotate(object: Container, duration: number, radians: number, delay: number = 0) {
    const tween = new TweenJS.Tween(object)
        .delay(delay)
        .to({ rotation: radians }, duration);

    return new Contract<void>((resolve) => {
        tween.onComplete(() => resolve(null));
        tween.start();
    });
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function ZoomIn(target: PIXIElement | PIXIElement[], duration: number, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None, spins: number = 0) {
    return Zoom(target, 0, 1, duration, delay, easing, spins);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function ZoomOut(target: PIXIElement | PIXIElement[], duration: number, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None, spins: number = 0) {
    return Zoom(target, 1, 0, duration, delay, easing, spins);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function BounceZoomIn(target: PIXIElement | PIXIElement[], duration: number, delay: number = 0, startSize: number = 0) {
    return Zoom(target, startSize, 1, duration, delay, TweenJS.Easing.Back.Out);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function BounceZoomOut(target: PIXIElement | PIXIElement[], duration: number, delay: number = 0) {
    return Zoom(target, 1, 0, duration, delay, TweenJS.Easing.Back.In);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function PivotBounceZoomIn(target: PIXIElement | PIXIElement[], duration: number, pivot: Point, delay: number = 0, startSize: number = 0) {
    return Zoom(target, startSize, 1, duration, delay, TweenJS.Easing.Back.Out, 0, pivot);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function PivotBounceZoomOut(target: PIXIElement | PIXIElement[], duration: number, pivot: Point, delay: number = 0) {
    return Zoom(target, 1, 0, duration, delay, TweenJS.Easing.Back.In, 0, pivot);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromTopIn(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, false, duration, anchor, delay, easing, 0);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromTopOut(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, true, duration, anchor, delay, easing, 0);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromLeftIn(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, false, duration, anchor, delay, easing, 3);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromLeftOut(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, true, duration, anchor, delay, easing, 3);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromBottomIn(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, false, duration, anchor, delay, easing, 2);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromBottomOut(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, true, duration, anchor, delay, easing, 2);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromRightIn(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, false, duration, anchor, delay, easing, 1);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function SwipeFromRightOut(target: PIXIElement | PIXIElement[], duration: number, anchor: number = 0, delay: number = 0, easing: Ease = TweenJS.Easing.Linear.None) {
    return SwipeFromDirection(target, true, duration, anchor, delay, easing, 1);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function FadeIn(target: PIXIElement | PIXIElement[], duration: number, delay: number = 0) {
    return Fade(target, false, duration, delay);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function FadeOut(target: PIXIElement | PIXIElement[], duration: number, delay: number = 0) {
    return Fade(target, true, duration, delay);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function EndlessHover(targets: PIXIElement | PIXIElement[], scale: number, duration: number, delay: number = 0, easing: Ease = quad.InOut): TweenJS.Tween {
    removeAllScaleTweens(targets);

    const target = Group(targets);

    if ((target as any).anchor) {
        const anchorable = target as any;
        if (anchorable.anchor.x !== 0.5) {
            anchorable.anchor.set(0.5);
            target.x += target.width * 0.5;
            target.y += target.height * 0.5;
        }
    } else {
        if (target.pivot.x === 0) {
            target.pivot.set(target.width * 0.5, target.height * 0.5);
            target.x += target.width * 0.5;
            target.y += target.height * 0.5;
        }
    }

    const targetInitialScale = new Point(target.scale.x, target.scale.y);
    const tweenScale = new Point(1, 1);

    const update = () => {
        if (!target) {
            TweenJS.remove(tween);
            return;
        } else {
            target.scale.set(targetInitialScale.x * tweenScale.x, targetInitialScale.y * tweenScale.y);
        }
    };

    const tween = new TweenJS.Tween(tweenScale)
        .to({ x: scale, y: scale }, duration)
        .easing(easing)
        .yoyo(true)
        .repeat(Infinity)
        .onUpdate(update);

    Timer.setTimeout(() => {
        tween.start();
    }, delay);

    return tween;
}

function Fade(targets: PIXIElement | PIXIElement[], out: boolean, duration: number, delay: number): Contract<void> {
    let grouped = false;

    const target = Group(targets);
    if (target !== targets) {
        grouped = true;
    }
    target.alpha = out ? 1 : 0;

    const tween = new TweenJS.Tween(target)
        .delay(delay)
        .to({ alpha: out ? 0 : 1 }, duration);

    return new Contract<void>((resolve) => {
        tween.onComplete(() => {
            tween.onComplete(null);
            if (grouped) {
                Ungroup(target);
            }
            resolve(null);
        });
        tween.start();
    });
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function Blink(targets: PIXIElement | PIXIElement[], flickerCount: number, flickerDuration: number, delay: number): Contract<void> {
    const target = Group(targets);
    const opposite = target.alpha > 0 ? 0 : 1;

    const tween = new TweenJS.Tween(target)
        .to({ alpha: opposite }, flickerDuration)
        .repeat(flickerCount)
        .yoyo(true);

    return new Contract<void>((resolve) => {
        tween.onComplete(() => {
            tween.onComplete(null);
            resolve(null);
            Ungroup(target);
        });
        Timer.setTimeout(() => tween.start(), delay);
    });
}

function SwipeFromDirection(
    targets: PIXIElement | PIXIElement[],
    out: boolean,
    duration: number,
    anchor: number,
    delay: number,
    easing: Ease,
    direction: number = 0 | 2
): Contract<void> {
    const target = Group(targets);

    const offScreenPosition: DualPosition = new DualPosition(new Position(target.landscape.x, target.landscape.y), new Position(target.portrait.x, target.portrait.y));
    const destination: DualPosition = new DualPosition();

    if (direction === 0) {
        // top
        offScreenPosition.landscape.y = (canvasManager.viewport.landscape.height * anchor) - target.landscape.height - (target.parent as Container).landscape?.y;
        offScreenPosition.portrait.y = (canvasManager.viewport.portrait.height * anchor) - target.portrait.height - (target.parent as Container).portrait?.y;
    } else if (direction === 1) {
        // left
        offScreenPosition.landscape.x = (canvasManager.viewport.landscape.width * anchor) + (target.parent as Container).landscape?.x;
        offScreenPosition.portrait.x = (canvasManager.viewport.portrait.width * anchor) + (target.parent as Container).portrait?.x;
    } else if (direction === 2) {
        // bottom
        offScreenPosition.landscape.y = (canvasManager.viewport.landscape.height * (1 - anchor)) - (target.parent as Container).landscape?.y;
        offScreenPosition.portrait.y = (canvasManager.viewport.portrait.height * (1 - anchor)) - (target.parent as Container).portrait?.y;
    } else if (direction === 3) {
        // right
        offScreenPosition.landscape.x = (canvasManager.viewport.landscape.width * (1 - anchor)) - target.landscape.width + (target.parent as Container).landscape?.x;
        offScreenPosition.portrait.x = (canvasManager.viewport.portrait.width * (1 - anchor)) - target.portrait.width + (target.parent as Container).portrait?.x;
    }
    destination.landscape.y = out ? offScreenPosition.landscape.y : target.landscape.y;
    destination.landscape.x = out ? offScreenPosition.landscape.x : target.landscape.x;
    destination.portrait.y = out ? offScreenPosition.portrait.y : target.portrait.y;
    destination.portrait.x = out ? offScreenPosition.portrait.x : target.portrait.x;

    if (!out) {
        target.landscape.y = offScreenPosition.landscape.y;
        target.landscape.x = offScreenPosition.landscape.x;
        target.portrait.y = offScreenPosition.portrait.y;
        target.portrait.x = offScreenPosition.portrait.x;
    }

    const landscapeTween = new TweenJS.Tween(target.landscape)
        .delay(delay)
        .to({ y: destination.landscape.y, x: destination.landscape.x }, duration)
        .easing(easing);

    const portraitTween = new TweenJS.Tween(target.portrait)
        .delay(delay)
        .to({ y: destination.portrait.y, x: destination.portrait.x }, duration)
        .easing(easing);

    return new Contract<void>((resolve) => {
        landscapeTween.onComplete(() => {
            landscapeTween.onComplete(null);
            portraitTween.onComplete(null);
            Ungroup(target);
            resolve(null);
        });
        landscapeTween.start();
        portraitTween.start();
    });
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function Zoom(
    targets: PIXIElement | PIXIElement[],
    scaleFrom: number, scaleTo: number, duration: number, delay: number, easing: Ease,
    spins: number = 0, pivot: Point = null): Contract<void> {
    let target = CenterPivot(targets, null, pivot);

    const fromScale = new Point(scaleFrom * target.scale.x, scaleFrom * target.scale.y);
    const endScale = new Point(scaleTo * target.scale.x, scaleTo * target.scale.y);

    if (target instanceof Text) {
        target.scale.set(fromScale.x, fromScale.y);
    } else {
        target.landscape.scale.set(fromScale.x, fromScale.y);
        target.portrait.scale.set(fromScale.x, fromScale.y);
    }

    const scaleObj = { x: fromScale.x, y: fromScale.x };

    const update = () => {
        if (!target) {
            return;
        }

        if (target instanceof Text && target.transform) {
            target.scale.set(scaleObj.x, scaleObj.y);
        } else {
            target.landscape.scale.x = scaleObj.x;
            target.landscape.scale.y = scaleObj.y;
            target.portrait.scale.x = scaleObj.x;
            target.portrait.scale.y = scaleObj.y;
        }

        if (target && (target.landscape.scale || target.portrait.scale)) {
            if (spins > 0) {
                target.rotation = Math.PI * 2 * spins * ((target.landscape || target.portrait).scale.x - fromScale.x) / (endScale.x - fromScale.x);
            }
        }
    };

    const tween = new TweenJS.Tween(scaleObj)
        .delay(delay)
        .to(endScale, duration)
        .easing(easing)
        .onUpdate(update);

    return new Contract<void>((resolve) => {
        tween.onComplete(() => {
            tween.onComplete(null);
            if (target) {
                ResetPivot(target);
                Ungroup(target);
                if (scaleTo === 0) {
                    if (targets && (targets as any).length) {
                        for (const groupedTarget of targets as PIXIElement[]) {
                            if (groupedTarget instanceof Text) {
                                groupedTarget.scale.x = groupedTarget.scale.y = scaleTo;
                            } else {
                                groupedTarget.landscape.scale.x = groupedTarget.landscape.scale.y = scaleTo;
                                groupedTarget.portrait.scale.x = groupedTarget.portrait.scale.y = scaleTo;
                            }
                        }
                    }
                }
                if (target.name === "tempContainer") {
                    target = null;
                }
                resolve(null);
            }
        });
        tween.start();
    });
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function Pulse(element: Sprite | Text | BitmapText | Container, scale: number = 1.1, duration: number = 100, easing: Ease = TweenJS.Easing.Linear.None) {

    TWEEN.removeAll(element.landscape.scale);
    TWEEN.removeAll(element.portrait.scale);

    const tweens = [];
    if (element instanceof Text) {
        tweens.push(() => Contract.wrapTween(
            new TweenJS.Tween(element.scale)
                .to({ x: `*${scale}`, y: `*${scale}` }, duration)
                .yoyo(true)
                .easing(easing)
                .repeat(1)
        ));
    } else {
        tweens.push(
            () => Contract.wrapTween(
                new TweenJS.Tween(element.landscape.scale)
                    .to({ x: `*${scale}`, y: `*${scale}` }, duration)
                    .yoyo(true)
                    .easing(easing)
                    .repeat(1)
            ),
            () => Contract.wrapTween(
                new TweenJS.Tween(element.portrait.scale)
                    .to({ x: `*${scale}`, y: `*${scale}` }, duration)
                    .yoyo(true)
                    .easing(easing)
                    .repeat(1)
            )
        );
    }

    return new Parallel([
        ...tweens,
        () => Flash(element, duration, easing)
    ]);
}

/**
 * @deprecated  BaseAnimations will be removed in V5
 */
export function Flash(element: Sprite | Text | BitmapText | Container, duration: number = 100, easing: Ease = TweenJS.Easing.Linear.None, brightness: number = 2) {
    const highlight = new AdjustmentFilter({
        brightness: 1
    });

    element.filters = [highlight];

    return Contract.wrapTween(
        new TweenJS.Tween(highlight)
            .to({ brightness }, duration)
            .easing(easing)
            .yoyo(true)
            .repeat(1)
            .onComplete(() => element.filters = [])
    );
}

function removeAllScaleTweens(targets: PIXIElement | PIXIElement[]) {
    if ((targets as any).length) {
        for (const target of targets as PIXIElement[]) {
            TweenJS.removeAll(target.scale);
        }
    } else {
        TweenJS.removeAll((targets as PIXIElement).scale);
    }
}
